<template>
    <div class="animated fadeIn">
      <div class="title font-300 font-24 mb-15">
        {{this.$route.name}}
      </div>
      <div class="box">
        <div class="p-15 pb-0">
          <div class="row">
            <div class="col-6">
              <a @click="openPage('/collectStamp')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
            </div>
          </div>
        </div>
        <hr class="mb-0">
        <div class="p-15 pt-0">
          <div class="row justify-content-center mt-30">
            <div class="col-sm-10">
              <form @submit.prevent="validateRegister">
                <b-row class="mb-20">
                  <b-col sm="2">
                    <label for="name_banner">Name</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="name_banner" v-model="name" name="name" v-validate="'required'" type="text"></b-form-input>
                    <span class="error">{{ errors.first('name') }}</span>
                  </b-col>
                </b-row>
                <div class="text-right">
                  <button type="submit" class="btn-primary">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { Auth } from '@/api'
  
  export default {
    name: 'addSlideBanner',
    data: function () {
      return {
        messageError: 'data saved successfully!',
        titleMessageError: 'Success',
        notificationSystem: {
          options: {
            success: {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            }
          }
        },
        name: '',
        name_voucher: '',
        amount: 0,
        description: '',
        imageData: '',
        file: null,
        url: '',
        selected: 0,
        options: [
          { value: 0, text: 'No' },
          { value: 1, text: 'Yes' }
        ],
        money: {
          decimal: ",",
          thousands: ".",
          prefix: "",
          suffix: "",
          precision: 0,
          masked: false
        },
        money2: {
          decimal: ",",
          thousands: ".",
          prefix: "IDR ",
          suffix: "",
          precision: 2,
          masked: false
        }
      }
    },
    methods: {
      validateRegister () {
        this.$validator.validateAll().then((result) => {
          if(result) {
            axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
            var data = {
              name: this.name
            }
            // eslint-disable-next-line no-unused-vars
            axios.put('crm/v1/collect_stamp/'+(this.$route.query.id), data).then(response => {
              // console.log('test', response)
              this.$router.push('/collectStamp')
              this.$toast.success('data saved successfully!', 'Success', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            // eslint-disable-next-line no-unused-vars
            }).catch(error => {
              // console.log('error', error)
              this.$toast.success('cant saved data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            })
          } else {
            this.$toast.success('please fill in required fields!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }
        })
      },
      openPage (event) {
        this.$router.push(event)
      },
      previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
      },
      fetchData() {
        // this.$route.query.id
        axios.get('crm/v1/collect_stamp/'+(this.$route.query.id)).then(response => {
          this.name = response.data.data.name
      }).catch(error => {
        console.log('error', error)
      })
      }
    },
    created() {
        this.fetchData()
    }
  }
  </script>
  
  <style>
  </style>
  